import type React from 'react';
import { useContext } from 'react';
import { FormattedNumber } from 'react-intl';
import { WebshopContext } from '../WebshopContext/WebshopContextProvider';
import { currencyTest } from '../../../js/statsig/ActiveFlags';

export interface Price {
  currency: string;
  value: number;
}

interface FormatPriceProps {
  price: Price;
}

const FormatPrice: React.FC<FormatPriceProps> = ({
  price: { currency, value },
}) => {
  const { experimentFlag, experimentVariation } = useContext(WebshopContext);

  if (
    experimentFlag === currencyTest.flagKey &&
    experimentVariation === currencyTest.variationB
  ) {
    return (
      <FormattedNumber
        value={value}
        minimumFractionDigits={2}
        maximumFractionDigits={2}
      />
    );
  }

  return (
    <FormattedNumber
      value={value}
      style="currency"
      currency={currency}
    />
  );
};

export default FormatPrice;
